import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import cookie from 'react-cookie';
import { CookieSetting } from '../../constants/Setting';
import { connect } from 'react-redux';
import { siteImageDisplay } from '../../actions';

/**
 * ページ遷移したときに実行されるアクション
 *
 * @class PageMove
 * @extends {Component}
 */
class PageMove extends React.Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string,
      hash: PropTypes.string,
      search: PropTypes.string,
    }).isRequired,
    children: PropTypes.node.isRequired,
  };

  /**
   * @param {*} prevProps Previous Props
   * @returns {null} Null
   * @memberof PageMove
   */
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      cookie.save(
        CookieSetting.SITE_IMAGE_VISIBLE.name,
        CookieSetting.SITE_IMAGE_VISIBLE.off,
        CookieSetting.SITE_IMAGE_VISIBLE.option,
      );
      siteImageDisplay(CookieSetting.SITE_IMAGE_VISIBLE.off);
    }
  }

  /**
   * @returns {node} Children
   * @memberof PageMove
   */
  render() {
    return this.props.children;
  }
}

const PageMoveContainer = connect(
  (state, props) => {
    return {};
  },
  (dispatch, props) => {
    return {
      siteImageDisplay: (visible) => dispatch(siteImageDisplay(visible)),
    };
  },
)(PageMove);

export default withRouter(PageMoveContainer);
